@use '../../design-tokens/border-radius/border-radius' as *;
@use '../../design-tokens/typography/typography' as *;

@layer design-system {
  .container {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 5px 11px;
    border: 1px solid transparent;
    outline: none;
    cursor: pointer;
    @include border-radius-r2;

    > span {
      @include typography-v2-body-sm;
    }

    &:focus-within {
      outline: 1px solid var(--border-focus);
    }

    &:disabled {
      background-color: transparent;
      color: var(--surface-neutral);
      pointer-events: none;

      &.outline {
        border-color: var(--border-disabled);
      }
    }

    &.input.solid:not(:disabled) {
      background-color: var(--surface-default);
      color: var(--text-default);

      &:not(.active):hover {
        background-color: var(--surface-hover);
      }

      &:not(.active):focus-visible {
        outline: 2px solid var(--border-focus);
      }

      &.active {
        background-color: var(--surface-primary);
        color: var(--text-inverse);
      }
    }

    &.input.outline:not(:disabled) {
      background-color: var(--surface-default);
      color: var(--text-default);
      border-color: var(--border-default);

      &:not(.active):hover {
        background-color: var(--surface-hover);
        border-color: var(--border-hover);
      }

      &:not(.active):focus-visible {
        outline: 2px solid var(--border-focus);
      }

      &.active {
        background-color: var(--surface-primary);
        color: var(--text-inverse);
        border-color: var(--border-primary);
      }
    }

    &.choice.solid:not(:disabled) {
      background-color: var(--surface-default);
      color: var(--text-default);

      &:not(.active):hover {
        background-color: var(--surface-hover);
      }

      &:not(.active):focus-visible {
        outline: 2px solid var(--border-focus);
      }

      &.active {
        background-color: transparent;
        color: var(--text-primary);
        border-color: var(--border-primary);
      }
    }

    &.choice.outline:not(:disabled) {
      background-color: transparent;
      color: var(--text-default);
      border-color: var(--border-default);

      &:not(.active):hover {
        background-color: var(--surface-hover);
        border-color: var(--border-hover);
      }

      &:not(.active):focus-visible {
        outline: 2px solid var(--border-focus);
      }

      &.active {
        background-color: transparent;
        color: var(--text-primary);
        border-color: var(--border-primary);
      }
    }

    &.filter.solid:not(:disabled) {
      background-color: var(--surface-default);
      color: var(--text-default);

      &:hover .closeIcon {
        fill: var(--icon-critical);
      }
    }

    &.filter.outline:not(:disabled) {
      background-color: transparent;
      color: var(--text-default);
      border-color: var(--border-default);

      &:hover .closeIcon {
        fill: var(--icon-critical);
      }
    }
  }

  .iconContainer {
    display: inline-flex;
  }

  .leftIcon {
    fill: currentColor;
  }

  .rightIcon {
    fill: currentColor;
  }

  .closeIcon {
    margin-left: 8px;
    fill: var(--icon-default);
  }
}
